module.exports = __webpack_public_path__ + "static/brittany-wrigley-afbea6920ae223d806c4af7959208c33.jpg";